import "./StrategyBuilder.scss";
import "./views";

import Components from "./components";
import Services from "./services";

const rootDir = "app/strategybuilder";

export default angular.module("tfApp.strategy-builder", [Components(rootDir), Services])
                      .name;
